import type { EventType } from 'parser/core/Events';
import { SELECTED_PLAYER, SELECTED_PLAYER_PET } from './Analyzer';

export interface SpellInfo {
  id: number;
}
export type SpellFilter<T extends SpellInfo = SpellInfo> = T | readonly T[];

class EventFilter<T extends EventType> {
  eventType: T;
  constructor(eventType: T) {
    this.eventType = eventType;
  }
  private _by: number | undefined;
  by(value: number) {
    if (!EventFilter.validateBy(value)) {
      throw new Error(`by filter not recognized: ${value}`);
    }
    this._by = value;
    return this;
  }
  getBy() {
    return this._by;
  }
  static validateBy(value: number) {
    const VALID_BY_FLAGS = SELECTED_PLAYER | SELECTED_PLAYER_PET;
    return (value & VALID_BY_FLAGS) === value;
  }
  private _to: number | undefined;
  to(value: number) {
    // TODO: Allow `this.selectedCombatant` (i.e. instances of Combatant) as value instead
    this._to = value;
    return this;
  }
  getTo() {
    return this._to;
  }
  private _spell: SpellFilter | undefined;
  spell<T extends SpellInfo = SpellInfo>(value: SpellFilter<T>) {
    // TODO: Use spell id instead
    if (typeof value !== 'object') {
      throw new Error('The spell filter must be a spell object, not a spell id.');
    }
    this._spell = value;
    return this;
  }
  getSpell() {
    return this._spell;
  }
}

export default EventFilter;
